import h, { FunctionComponent } from 'preact';
import Currency from '../common/Currency';
import DeliveryOptions from './DeliveryOptions';
import { DeliveryOption } from '../types';

const BasketTableFooter: FunctionComponent<BasketTableFooterProps> = ({ itemCount, subtotal, subtotalExcludingDelivery, tax, taxExcludingDelivery, total, deliveryOptions, deliveryOption, deliveryPrice }) => {
    return <tfoot class="basket__totals">
    <tr class="border-bottom border-lg-0 p-4">
        <th scope="row" colSpan={5} class="col-6 col-lg-11 text-left text-lg-right text-blue font-weight-normal p-0 p-lg-4"> Subtotal </th>
        <td class="col-6 col-lg-1 border-1 border-lg-left border-lg-right border-lg-bottom font-weight-bold text-blue p-0 p-lg-4">
            <span class="d-inline-block" id="js-basket-total">
                <Currency amount={subtotal} />
            </span>
        </td>
    </tr>
    <tr class="border-bottom border-lg-0 p-4">
        <th scope="row" colSpan={5} class="col-9 col-lg-11 text-left text-lg-right text-blue font-weight-normal p-0 p-lg-4"> Delivery cost calculated at checkout </th>
        <td class="col-3 col-lg-1 border-1 border-lg-left border-lg-right border-lg-bottom font-weight-bold text-blue p-0 p-lg-4"> <span aria-hidden="true">—</span> </td>
    </tr>
    <tr class="border-bottom border-lg-0 p-4">
        <th scope="row" colSpan={5} class="col-6 col-lg-11 text-left text-lg-right text-blue font-weight-normal p-0 p-lg-4"> VAT </th>
        <td class="col-6 col-lg-1 col-lg-2 border-1 border-lg-left border-lg-right border-lg-bottom font-weight-bold text-blue p-0 p-lg-4">
            <span class="d-inline-block" id="js-basket-total">
                <Currency amount={taxExcludingDelivery} />
            </span>
        </td>
    </tr>
    <tr class="border-bottom border-lg-0 p-4">
        <th scope="row" colSpan={5} class="col-6 col-lg-11 text-left text-lg-right text-blue font-weight-normal p-0 p-lg-4"> Total </th>
        <td class="col-6 col-lg-1 border-1 border-lg-left border-lg-right border-lg-bottom font-weight-bold text-blue p-0 p-lg-4">
            <span class="d-inline-block" aria-live="polite" id="js-basket-total">
                <Currency amount={subtotalExcludingDelivery} />
            </span>
        </td>
    </tr>
    </tfoot>;
};

interface BasketTableFooterProps {
    itemCount: number;
    subtotal: string;
    subtotalExcludingDelivery: string;
    tax: string;
    taxExcludingDelivery: string;
    total: string;
    deliveryOptions: Array<DeliveryOption>;
    deliveryOption: number | null;
    deliveryPrice: string | null;
}

export default BasketTableFooter;
